var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "template-selector flex-column-reverse" },
    [
      _c(
        "div",
        { class: _vm.selectorClass, on: { click: _vm.goSelectTemplate } },
        [
          _vm.hasTemplate
            ? _c(
                "div",
                [
                  _c("template-card", {
                    attrs: {
                      "delete-template": true,
                      actions: true,
                      "select-page": false,
                      "edit-template": true,
                      "template-id": _vm.stage.templateId,
                      thumbnail: _vm.stage.templateThumbnail,
                      "template-name": _vm.stage.templateName,
                    },
                    on: {
                      edit: _vm.handleTemplateEdit,
                      preview: _vm.handleTemplatePreview,
                      delete: _vm.handleTemplateDelete,
                    },
                  }),
                ],
                1
              )
            : _c("p", { staticClass: "text-regular-gray text-center mb-0" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$tc("global.words.click", 1)) +
                    "\n      "
                ),
                _c("a", { staticClass: "text-primary select-template" }, [
                  _vm._v(_vm._s(_vm.$t("global.words.here"))),
                ]),
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("drip-campaigns.stages.editEmails.toBegin")) +
                    "\n      "
                ),
                _c("br"),
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "drip-campaigns.stages.editEmails.designingYourEmail"
                    )
                  ) + "\n    "
                ),
              ]),
        ]
      ),
      _vm._v(" "),
      _c("html-template-editor", {
        ref: "templateEditorContainer",
        attrs: {
          "template-id": _vm.stage.templateId,
          "template-name": _vm.stage.templateName,
          "template-source-url": _vm.templateSourceUrl,
          "preview-template": _vm.previewTemplate,
          "allow-save-as": false,
        },
        on: { save: _vm.onSaveHandler, hidden: _vm.handleEditorHidden },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }